export default __webpack_public_path__ + "static/media/financialsituation1Img4.f517372a.png";